module.exports = __webpack_public_path__ + "img/1.e46549e2.png";